module.exports = __webpack_public_path__ + "img/9.648dbe0a.jpg";